import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const Layout = () => import('@/views/Layout.vue')
const Login = () => import('@/views/Login.vue')
const Home = () => import('@/views/Home.vue')
const LeadList = () => import('@/views/lead/LeadList.vue')
const LeadDetail = () => import('@/views/lead/LeadDetail.vue')
const LeadForm = () => import('@/views/lead/LeadForm.vue')
const CustomerList = () => import('@/views/customer/CustomerList.vue')
const CustomerForm = () => import('@/views/customer/CustomerForm.vue')
const QuoteList = () => import('@/views/quote/QuoteList.vue')
const QuoteForm = () => import('@/views/quote/QuoteForm.vue')
const PublicQuote = () => import('@/views/public/PublicQuote.vue')
const PublicContract = () => import('@/views/public/PublicContract.vue')
const PublicInvoice = () => import('@/views/public/PublicInvoice.vue')
const ContractList = () => import('@/views/contract/ContractList.vue')
const ContractDetail = () => import('@/views/contract/ContractDetail.vue')
const ContractTemplateList = () => import('@/views/system/ContractTemplateList.vue')
const ProjectList = () => import('@/views/project/ProjectList.vue')
const ProjectDetail = () => import('@/views/project/ProjectDetail.vue')
const ProductList = () => import('@/views/product/ProductList.vue')
const SubcontractorList = () => import('@/views/subcontractor/SubcontractorList.vue')
const SubcontractorForm = () => import('@/views/subcontractor/SubcontractorForm.vue')
const ContractTemplateForm = () => import('@/views/system/ContractTemplateForm.vue')
const ContractFromQuote = () => import('@/views/contract/ContractFromQuote.vue')
const ChangeOrderList = () => import('@/views/changeOrder/ChangeOrderList.vue')
const SalesAmount = () => import('@/views/sales/SalesAmount.vue')
const Report = () => import('@/views/report/Report.vue')
const SalesPersonReport = () => import('@/views/report/SalesPersonReport.vue')
const ScheduleCalendar = () => import('@/views/schedule/ScheduleCalendar.vue')
const FinanceCenter = () => import('@/views/finance/FinanceCenter.vue')
const LeadCostMonth = () => import('@/views/finance/LeadCostMonth.vue')
const SystemOverview = () => import('@/views/system/SystemOverview.vue')
const SystemUsers = () => import('@/views/system/SystemUsers.vue')
const SystemRoles = () => import('@/views/system/SystemRoles.vue')
const SystemMenus = () => import('@/views/system/SystemMenus.vue')
const MailSettings = () => import('@/views/system/MailSettings.vue')

const router = new VueRouter({
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/login', name: 'Login', component: Login },
    { path: '/dashboard', redirect: '/home' },
    {
      path: '/public/quote/:token',
      name: 'PublicQuote',
      component: PublicQuote,
      meta: { public: true }
    },
    {
      path: '/public/contract/:token',
      name: 'PublicContract',
      component: PublicContract,
      meta: { public: true }
    },
    {
      path: '/public/invoice/:token',
      name: 'PublicInvoice',
      component: PublicInvoice,
      meta: { public: true }
    },

    { path: '/leads', redirect: '/lead/list' },
    { path: '/leads/list', redirect: '/lead/list' },
    { path: '/leads/new', redirect: '/lead/new' },

    { path: '/customers', redirect: '/customer/list' },
    { path: '/customers/list', redirect: '/customer/list' },
    { path: '/customers/new', redirect: '/customer/new' },

    { path: '/opportunities', redirect: '/lead/list' },

    { path: '/quotes', redirect: '/quote/list' },
    { path: '/contracts', redirect: '/contract/list' },
    { path: '/change-orders', redirect: '/change-order/list' },
    { path: '/projects', redirect: '/project/list' },
    { path: '/products', redirect: '/product/list' },
    { path: '/products/list', redirect: '/product/list' },
    { path: '/subcontractors', redirect: '/subcontractor/list' },
    { path: '/reports', redirect: '/report/dashboard' },
    { path: '/invoices', redirect: '/finance/overview' },

    {
      path: '/lead',
      component: Layout,
      children: [
        { path: 'list', name: 'LeadList', component: LeadList, meta: { titleKey: 'nav.leads', permission: 'LEAD_MANAGEMENT' } },
        { path: 'new', name: 'LeadNew', component: LeadForm, meta: { titleKey: 'nav.leads', subtitleKey: 'pipelineList.leads', permission: 'LEAD_MANAGEMENT' } },
        { path: 'detail/:id', name: 'LeadDetail', component: LeadDetail, meta: { titleKey: 'nav.leads', subtitleKey: 'pipelineList.leads', permission: 'LEAD_MANAGEMENT' } }
      ]
    },
    {
      path: '/customer',
      component: Layout,
      children: [
        { path: 'list', name: 'CustomerList', component: CustomerList, meta: { titleKey: 'nav.customers', permission: 'CUSTOMER_MANAGEMENT' } },
        { path: 'new', name: 'CustomerNew', component: CustomerForm, meta: { titleKey: 'nav.customers', subtitleKey: 'pipelineList.customers', permission: 'CUSTOMER_MANAGEMENT' } },
        { path: 'edit/:id', name: 'CustomerEdit', component: CustomerForm, meta: { titleKey: 'nav.customers', subtitleKey: 'pipelineList.customers', permission: 'CUSTOMER_MANAGEMENT' } }
      ]
    },
    {
      path: '/quote',
      component: Layout,
      children: [
        { path: 'list', name: 'QuoteList', component: QuoteList, meta: { titleKey: 'nav.quotes', permission: 'QUOTE_MANAGEMENT' } },
        { path: 'new', name: 'QuoteNew', component: QuoteForm, meta: { titleKey: 'nav.quotes', subtitleKey: 'pipelineList.quotes', permission: 'QUOTE_MANAGEMENT' } },
        { path: 'edit/:id', name: 'QuoteEdit', component: QuoteForm, meta: { titleKey: 'nav.quotes', subtitleKey: 'pipelineList.quotes', permission: 'QUOTE_MANAGEMENT' } }
      ]
    },
    {
      path: '/contract',
      component: Layout,
      children: [
        { path: 'list', name: 'ContractList', component: ContractList, meta: { titleKey: 'nav.contracts', permission: 'CONTRACT_MANAGEMENT' } },
        { path: 'from-quote', name: 'ContractFromQuote', component: ContractFromQuote, meta: { titleKey: 'nav.contracts', subtitleKey: 'pipelineList.fromQuote', permission: 'CONTRACT_MANAGEMENT' } },
        { path: 'detail/:id', name: 'ContractDetail', component: ContractDetail, meta: { titleKey: 'nav.contracts', subtitleKey: 'pipelineList.contracts', permission: 'CONTRACT_MANAGEMENT' } }
      ]
    },
    {
      path: '/change-order',
      component: Layout,
      children: [
        {
          path: 'list',
          name: 'ChangeOrderList',
          component: ChangeOrderList,
          meta: { titleKey: 'nav.changeOrders', permission: 'CONTRACT_MANAGEMENT' }
        }
      ]
    },
    {
      path: '/project',
      component: Layout,
      children: [
        { path: 'list', name: 'ProjectList', component: ProjectList, meta: { titleKey: 'nav.projects', permission: 'PROJECT_MANAGEMENT' } },
        { path: 'detail/:id', name: 'ProjectDetail', component: ProjectDetail, meta: { titleKey: 'nav.projects', subtitleKey: 'pipelineList.projects', permission: 'PROJECT_MANAGEMENT' } }
      ]
    },
    {
      path: '/subcontractor',
      component: Layout,
      children: [
        { path: 'new', name: 'SubcontractorNew', component: SubcontractorForm, meta: { titleKey: 'nav.subcontractors', subtitleKey: 'pipelineList.subcontractors', permission: 'SUBCONTRACTOR_LIBRARY' } },
        { path: 'edit/:id', name: 'SubcontractorEdit', component: SubcontractorForm, meta: { titleKey: 'nav.subcontractors', subtitleKey: 'pipelineList.subcontractors', permission: 'SUBCONTRACTOR_LIBRARY' } },
        { path: 'list', name: 'SubcontractorList', component: SubcontractorList, meta: { titleKey: 'nav.subcontractors', permission: 'SUBCONTRACTOR_LIBRARY' } }
      ]
    },
    {
      path: '/product',
      component: Layout,
      children: [
        { path: 'list', name: 'ProductList', component: ProductList, meta: { titleKey: 'nav.products', permission: 'PRODUCT_MANAGEMENT' } }
      ]
    },
    {
      path: '/finance',
      component: Layout,
      children: [
        { path: 'overview', name: 'FinanceCenter', component: FinanceCenter, meta: { titleKey: 'nav.finance', permission: 'INVOICE_PAYMENT' } },
        {
          path: 'lead-cost',
          name: 'LeadCostMonth',
          component: LeadCostMonth,
          meta: { titleKey: 'leadCostMonthPage.title', subtitleKey: 'leadCostMonthPage.subtitle', permission: 'INVOICE_PAYMENT' }
        }
      ]
    },
    {
      path: '/sales-amount',
      component: Layout,
      children: [
        { path: 'list', name: 'SalesAmount', component: SalesAmount, meta: { titleKey: 'nav.salesAmount', permission: 'REPORTS' } }
      ]
    },
    {
      path: '/report',
      component: Layout,
      children: [
        { path: 'dashboard', name: 'Report', component: Report, meta: { titleKey: 'nav.reports', permission: 'REPORTS' } },
        {
          path: 'sales-person',
          name: 'SalesPersonReport',
          component: SalesPersonReport,
          meta: { titleKey: 'salesPersonReportPage.title', subtitleKey: 'salesPersonReportPage.subtitle', permission: 'REPORTS' }
        }
      ]
    },
    {
      path: '/schedule',
      component: Layout,
      children: [
        { path: '', redirect: 'calendar' },
        {
          path: 'calendar',
          name: 'ScheduleCalendar',
          component: ScheduleCalendar,
          meta: { titleKey: 'schedulePage.title' }
        }
      ]
    },
    {
      path: '/system',
      component: Layout,
      children: [
        {
          path: 'overview',
          name: 'SystemOverview',
          component: SystemOverview,
          meta: { titleKey: 'nav.systemOverview', permission: 'SYSTEM_MANAGEMENT' }
        },
        {
          path: 'mail-settings',
          name: 'MailSettings',
          component: MailSettings,
          meta: { titleKey: 'nav.emailConfig', subtitleKey: 'emailConfigPage.subtitle' }
        },
        {
          path: 'users',
          name: 'SystemUsers',
          component: SystemUsers,
          meta: { titleKey: 'nav.users', permission: 'SYSTEM_USERS' }
        },
        {
          path: 'roles',
          name: 'SystemRoles',
          component: SystemRoles,
          meta: { titleKey: 'nav.roles', permission: 'SYSTEM_ROLES' }
        },
        {
          path: 'menus',
          name: 'SystemMenus',
          component: SystemMenus,
          meta: { titleKey: 'nav.menus', permission: 'SYSTEM_MENUS' }
        },
        {
          path: 'contract-templates/new',
          name: 'ContractTemplateNew',
          component: ContractTemplateForm,
          meta: { titleKey: 'nav.templates', subtitleKey: 'pipelineList.contractTemplates', permission: 'CONTRACT_TEMPLATE_LIST' }
        },
        {
          path: 'contract-templates/edit/:id',
          name: 'ContractTemplateEdit',
          component: ContractTemplateForm,
          meta: { titleKey: 'nav.templates', subtitleKey: 'pipelineList.contractTemplates', permission: 'CONTRACT_TEMPLATE_LIST' }
        },
        {
          path: 'contract-templates',
          name: 'ContractTemplates',
          component: ContractTemplateList,
          meta: { titleKey: 'nav.templates', permission: 'CONTRACT_TEMPLATE_LIST' }
        }
      ]
    },

    {
      path: '/home',
      component: Layout,
      children: [
        { path: '', name: 'Home', component: Home, meta: { titleKey: 'nav.home' } }
      ]
    },

    { path: '*', redirect: '/home' }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.public) {
    return next()
  }

  const token = store.state.token || localStorage.getItem('token')
  if (token && to.path === '/login') {
    return next('/home')
  }
  if (!token) {
    if (to.path === '/login') return next()
    return next('/login')
  }

  // token 在 localStorage 里有时效，但 userInfo 只存在内存中；首页等无 meta.permission 的路由不会触发下面的拉取，
  // 刷新后会出现侧栏显示 User、菜单为空，因此有 token 且尚未拿到 userId 时先统一拉一次。
  const uid = store.state.userInfo && store.state.userInfo.userId
  if (uid === null || uid === undefined) {
    try {
      await store.dispatch('fetchUserInfo')
    } catch (e) {
      store.dispatch('logout')
      return next('/login')
    }
  }

  const needPermission = to.matched.some(r => r.meta && r.meta.permission)
  if (needPermission) {
    const permission = to.meta.permission
    const permissions = store.state.userInfo.permissions || []

    if (!permissions.length) {
      try {
        await store.dispatch('fetchUserInfo')
      } catch (e) {
        store.dispatch('logout')
        return next('/login')
      }
    }

    const permissionsAfter = store.state.userInfo.permissions || []
    if (permission && !permissionsAfter.includes(permission)) {
      return next('/home')
    }
  }

  return next()
})

export default router
